import { useCallback, useEffect, useRef, useState } from "react";
import UserAccess from "./UserAccess";
import { getCostCenterBySearchString } from "Store/Organization/CostCenters/CostCentersAction";
import { useDispatch, useSelector } from "react-redux";
import { Checkbox } from "rsuite";
import { addEmployeeToCostCenter, setIsEmployeeAddedToCostCenter } from "Store/Identity/UserBySearchText/UserBySearchTextAction";
import { getAllUsers, getUserCostCentersDropDownList, getUserCostCentersModulesList, setSaveUserCostCenterModules } from "Store/AssetInventory/Users/UsersAction";
import { popupInitialData } from "utils";
import sucessBee from '../../../../assets/images/SuccessBee.svg'
import { getCostCenterByIdAndRole, setCostCenterByIdAndRole } from "Store/AssetInventory/BranchAdminAccess/BranchAdminAccessAction";

const UserAccessContainer = (props: any) => {
  const {
    rowData = {},
    userUpdated,
    userData,
    setIsClearValue,
    isClearValue,
    setChangedArr,
    changedArr,
    setShowUserAccessPopup,
    filterObj
  } = props
  const dispatch = useDispatch();

  //Search CostCenter State
  const [costCentersBySearchList, setCostCentersBySearchList] = useState([]);
  const [searchedUserCostCenter, setSearchedUserCostCenter] = useState<any>();
  const [costCenterSearchText, setCostCenterSearchText] = useState<string>("");
  const [popupContent, setpopupContent] = useState<any>(popupInitialData);

  //Filter CostCenterState
  const [userCostCentersDropDownTemp, setUserCostCentersDropDownTemp] = useState([]);
  const [selectedUserCostCenter, setSelectedUserCostCenter] = useState<any>([]);
  const [isSelectAllClicked, setIsSelectAllClicked] = useState(false);


  const [pagesCount, setPagesCount] = useState<number>(0)
  const [serverTotal, setServerTotal] = useState(0)
  const sortData: any = useRef();
  const paginationData: any = useRef();
  const selectedCostCenters: any = useRef();
  const [addUserCostCenterError, setAddUserCostCenterError] = useState<any>('')
  const changedTableTemp: any = useRef(null);
  const initialTableData: any = useRef([]);
  const [tableData, setTableData] = useState<any>([]);
  const [showAlert, setShowAlert] = useState<any>({});

  const {
    costCenterByIdAndRole,
    userCostCentersDropdownList,
    isCostCenterAddedToUser,
    userCostCentersModulesList,
    isUserCostCentersModulesSaved
  }: any = useSelector((state: any) => ({
    costCenterByIdAndRole: state.BranchAdminAccessReducer.costCenterByIdAndRole,
    userCostCentersDropdownList: state.UsersReducer.userCostCentersDropdownList,
    isCostCenterAddedToUser: state.UserFilterBySearchTextReducers.isEmployeeAddedToCostCenter,
    userCostCentersModulesList: state.UsersReducer.userCostCentersModulesList,
    isUserCostCentersModulesSaved: state.UsersReducer.isUserCostCentersModulesSaved
  }));

  useEffect(() => {
    setCostCentersBySearchList([]);
    return () => {
      dispatch(setCostCenterByIdAndRole([]));
    }
  }, [])

  useEffect(() => {
    if (isClearValue) {
      clearValues();
      setIsClearValue(false);
    }
  }, [isClearValue]);

  useEffect(() => {
    if (userCostCentersDropdownList?.length > 0) {
      let val = userCostCentersDropdownList?.map((item?: any) =>
        ({ value: item.value, label: item.text, key: item.value })
      )
      setUserCostCentersDropDownTemp(val)
    }
  }, [userCostCentersDropdownList])

  useEffect(() => {
    if (serverTotal && paginationData?.current?.pageSize) {
      let pageSize = paginationData?.current?.pageSize
      let tempPageCount = serverTotal > pageSize ? Math.ceil(serverTotal / pageSize - 1) : 0
      setPagesCount(tempPageCount)
    }
  }, [serverTotal, paginationData?.current?.pageSize])

  useEffect(() => {
    if (costCenterByIdAndRole?.length) {
      const costcenterDropdownListTemp = costCenterByIdAndRole?.map((item: any) => ({ ...item, label: item?.text }));
      setCostCentersBySearchList(costcenterDropdownListTemp);
    }
  }, [costCenterByIdAndRole])

  const hideDialog = () => setpopupContent({ ...popupContent, isDialogVisible: false });

  useEffect(() => {
    if (isUserCostCentersModulesSaved != null) {
      if (isUserCostCentersModulesSaved) {
        setpopupContent({
          ...popupContent,
          title: "Success",
          titleImg: sucessBee,
          isDialogVisible: true,
          isTitleWarning: false,
          subtextcontent: "Successfully saved the user access",
          outlineBtnText: "Ok",
          isSingleConfirmationBtn: true,
          isCommentboxVisible: false,
          isCommentBoxRequire: false,
          popupOutlinebtnOnclick: () => {
            hideDialog();
            clearValues();
            setShowUserAccessPopup(false)
            dispatch(getAllUsers(filterObj)) 
          }
        });   
      } else {
        setShowAlert({
          type: 'warning',
          text: "Error occured while submitting the request!!",
          showAddAlert: false,
          showSubmitAlert: true
        })
        setTimeout(() => {
          setShowAlert(undefined);
        }, 6000);
      }
      dispatch(setSaveUserCostCenterModules(null))
    }
  }, [isUserCostCentersModulesSaved])

  const handleChangeSelectCostCenter = (value: any) => {
    if (userCostCentersDropdownList?.length) {
      const isSelectAllClicked = value?.length === costCenterByIdAndRole?.length;
      setIsSelectAllClicked(isSelectAllClicked);
    }
    setSelectedUserCostCenter(value)
    costCenterSelectOnBlur(value)
  }

  const searchCostCenter = (value: any, action: any) => {
    if (action.action === "input-change") {
      setCostCenterSearchText(value)
    }
  };

  useEffect(() => {
    if (costCenterSearchText?.length > 2) {
      dispatch(getCostCenterByIdAndRole({userId: userData?.userId,
        searchValue: costCenterSearchText}))
    }
  }, [costCenterSearchText])

  const costCenterSelectOnBlur = (value: any) => {
    let costCenterValue: any = []
    value?.map((item: any) => {
      costCenterValue.push(parseInt(item.value))
    })
    selectedCostCenters.current = costCenterValue;
    fetchGridData(selectedCostCenters.current);
  }

  const onIsCheckBoxChange = (rowData?: any, key?: any) => {
    let valArr: any = {}
    let gridDataTemp = changedTableTemp.current ? JSON.parse(JSON.stringify(changedTableTemp.current)) : []
    gridDataTemp?.map((item: any) => {
      if (item?.costCenterId == rowData?.costCenterId) {
        item[key] = !item[key]
        valArr = item
      }
    })
    if (valArr?.hasOwnProperty('costCenterId')) {
      changedArr?.map((item?: any, index?: any) => {
        if (item?.costCenterId == rowData?.costCenterId) {
          changedArr.splice(index, 1)
        }
      })
      changedArr.push(valArr)

      ///If we are changing it to initial state then remove the object from array
      if (changedArr?.length > 0) {
        changedArr?.map((item?: any, itemIndex?: any) => {
          initialTableData?.current?.map((val?: any, index?: any) => {
            if (item?.costCenterId == val?.costCenterId
              && item?.isAssetInventory == val?.isAssetInventory
              && item?.isAssetTraining == val?.isAssetTraining
              && item?.isMAScanning == val?.isMAScanning 
              && item?.isAssetMaintenance == val?.isAssetMaintenance
              && item?.costCenterName == val?.costCenterName
            ) {
              changedArr.splice(itemIndex, 1)
            }
          })
        })
        const temp = [...changedArr]
        setChangedArr([...temp])
      }
      changedTableTemp.current = gridDataTemp
      setTableData(gridDataTemp)
    }
  }

  const gridColumn = [
    {
      key: "costCenterName",
      title: "Approved Cost Center",
      Cell: (row: any) => {
        return (
          <p>{row?.rowData?.costCenterName}</p>
        )
      }
    },
    {
      key: "isAssetTraining",
      title: "Asset Training",
      Cell: (row: any) => {
        return (
          <Checkbox className="mb-0 checkboxName" onChange={() => onIsCheckBoxChange(row?.rowData, row?.column?.key)} checked={row?.rowData?.isAssetTraining}  data-attribute="UserAccess_container_Default_Checkbox" />
        );
      },
      isSortable: false
    },
    {
      key: "isAssetInventory",
      title: "Asset Inventory",
      Cell: (row: any) => {
        return (
          <Checkbox className="mb-0 checkboxName" onChange={() => onIsCheckBoxChange(row?.rowData, row?.column?.key)} checked={row?.rowData?.isAssetInventory}  data-attribute="UserAccess_container_Default_Checkbox_2" />
        );
      },
      isSortable: false
    },
    {
      key: "isMAScanning",
      title: "M&A Scanning",
      Cell: (row: any) => {
        return (
          <Checkbox className="mb-0 checkboxName" onChange={() => onIsCheckBoxChange(row?.rowData, row?.column?.key)} checked={row?.rowData?.isMAScanning}  data-attribute="UserAccess_container_Default_Checkbox_3" />
        );
      },
      isSortable: false
    },
    {
      key: "isAssetMaintenance",
      title: "Asset Maintenance",
      Cell: (row: any) => {
        return (
          <Checkbox className="mb-0 checkboxName" onChange={() => onIsCheckBoxChange(row?.rowData, row?.column?.key)} checked={row?.rowData?.isAssetMaintenance}  data-attribute="UserAccess_container_Default_Checkbox_4" />
        );
      },
      isSortable: false
    },
  ]

  const fetchAction = useCallback((fetchData: any) => {
    if (fetchData.action && fetchData.action === "paging") {
      paginationData.current = fetchData.data
      fetchGridData(selectedCostCenters.current, fetchData.data, sortData.current)
    }
    if (fetchData.action && fetchData.action === "sorting") {
      sortData.current = fetchData.data[0]
      fetchGridData(selectedCostCenters.current, paginationData.current, fetchData.data[0])
    }
  }, [])

  const fetchGridData = (costCenterValue?: any, pageData?: any, sortingData?: any) => {
    let payload: any = {
      userId: rowData?.userId,
      pageNumber: getPaginationData(costCenterValue, pageData),
      pageSize: pageData?.pageSize,
      CostCenterIdFilter: costCenterValue?.length ? costCenterValue : null,
      loggedInMail: userData?.emailId
    }
    if (sortingData?.key != '') {
      payload.sortBy = sortingData?.key;
      payload.sortOrder = sortingData?.sortDirection;
    }
    dispatch(getUserCostCentersModulesList(payload))

  }

  const getPaginationData = (costCenterValue?: any, pageData?: any) => {
    if (pageData?.pageIndex != undefined && costCenterValue?.length && costCenterValue != null && costCenterValue != undefined) {
      return 1
    } else if (pageData?.pageIndex != undefined) {
      return pageData?.pageIndex + 1
    } else {
      return 1
    }
  }

  useEffect(() => {
    if (userCostCentersModulesList?.data?.length > 0) {
      initialTableData.current = userCostCentersModulesList?.data;
      let userCostCentersModulesListTemp = JSON.parse(JSON.stringify(userCostCentersModulesList?.data))
      userCostCentersModulesListTemp?.map((initialVal?: any) => {
        changedArr?.map((changedVal?: any) => {
          if (initialVal?.costCenterId == changedVal?.costCenterId) {
            initialVal.isAssetInventory = changedVal?.isAssetInventory
            initialVal.isAssetTraining = changedVal?.isAssetTraining
            initialVal.isMAScanning = changedVal?.isMAScanning
            initialVal.isAssetMaintenance = changedVal?.isAssetMaintenance
            initialVal.costCenterName = changedVal?.costCenterName
          }
        })
      })
      changedTableTemp.current = userCostCentersModulesListTemp
      setServerTotal(userCostCentersModulesList?.totalRecords)
    }
    else if (userCostCentersModulesList?.data?.length == 0) {
      changedTableTemp.current = []
      setTableData([])
      setServerTotal(0)
    }
  }, [userCostCentersModulesList])

  const onClickAdd = (e: any) => {
    e.preventDefault();
    const payload = {
      costCenterId: parseInt(searchedUserCostCenter?.value),
      savedBy: userData?.emailId,
      userId: parseInt(rowData?.userId)
    }

    dispatch(addEmployeeToCostCenter(payload))
  }

  const addCostCenterInDropDownList = () => {
    dispatch(getUserCostCentersDropDownList(rowData?.userId,userData?.userId));
    if (isSelectAllClicked) {
      setSelectedUserCostCenter(userCostCentersDropDownTemp);
      costCenterSelectOnBlur(userCostCentersDropDownTemp)
    }
    else {
      fetchGridData(selectedCostCenters.current, paginationData.current, sortData.current)
    }
  }

  const dismissAlert = () => {
    setShowAlert(undefined);
  }

  useEffect(() => {
    if (isCostCenterAddedToUser === 'added') {
      setSearchedUserCostCenter('')
      addCostCenterInDropDownList()
      setShowAlert({
        type: 'success',
        text: "Successfully added the Cost Center to user",
        showAddAlert: true,
        showSubmitAlert: false
      })
    } else if (isCostCenterAddedToUser === 'exists') {
      setAddUserCostCenterError('Cost Center already added to user')
    } else if (isCostCenterAddedToUser === 'error') {
      setShowAlert({
        type: 'warning',
        text: "Error occured while adding the Cost Center!!",
        showAddAlert: true,
        showSubmitAlert: false
      })
    }
    setTimeout(() => {
      setShowAlert(undefined);
    }, 6000);
    dispatch(setIsEmployeeAddedToCostCenter(undefined))
  }, [isCostCenterAddedToUser])


  const handleChangeSearchCostCenter = (value: any) => {
    setSearchedUserCostCenter(value)
    setAddUserCostCenterError('')
  }

  const onCancelCostCenterClick = () => {
    setSearchedUserCostCenter(null)
    setCostCenterSearchText('')
    setAddUserCostCenterError('')
  }

  const handleClickReset = (e: any) => {
    e?.preventDefault();
    setCostCentersBySearchList([]);
    onCancelCostCenterClick();
  }


  const clearValues = () => {
    setSearchedUserCostCenter(null)
    setCostCentersBySearchList([])
    setCostCenterSearchText('')
    setAddUserCostCenterError('')
    setSelectedUserCostCenter(null)
    setUserCostCentersDropDownTemp([])
    setIsSelectAllClicked(false)
    changedTableTemp.current = []
    initialTableData.current = []
    setTableData([])
    setChangedArr([])
    selectedCostCenters.current = []
  }

  useEffect(() => {
    setTableData(changedTableTemp.current)
  }, [changedTableTemp.current])

  return <UserAccess
    rowData={rowData}
    userUpdated={userUpdated}
    handleChangeSearchCostCenter={handleChangeSearchCostCenter}
    costCenterSelectOnBlur={costCenterSelectOnBlur}
    handleChangeSelectCostCenter={handleChangeSelectCostCenter}
    costCenterSearchText={costCenterSearchText}
    searchCostCenter={searchCostCenter}
    costCentersBySearchList={costCentersBySearchList}
    searchedUserCostCenter={searchedUserCostCenter}
    gridData={tableData}
    gridColumn={gridColumn}
    fetchAction={fetchAction}
    pagesCount={pagesCount}
    paginationData={paginationData}
    serverTotal={serverTotal}
    userCostCentersDropDownTemp={userCostCentersDropDownTemp}
    selectedUserCostCenter={selectedUserCostCenter}
    onClickAdd={onClickAdd}
    addUserCostCenterError={addUserCostCenterError}
    onCancelCostCenterClick={onCancelCostCenterClick}
    handleClickReset={handleClickReset}
    showAlert={showAlert}
    dismissAlert={dismissAlert}
    popupContent={popupContent}
    hideDialog = {hideDialog}
  />
}

export default UserAccessContainer;